import React from 'react';

import styles from './vpn-required-styles.module.css';


const VpnRequired = () => {
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img src="https://spectrum.adobe.com/static/404.svg" alt="Error illustration" />
      </div>
      <div className={styles.header}>VPN_DISCONNECTED OR FAILED_TO_VERIFY</div>
      <q className={styles.text}>
        You will NOT receive Chats or Voice calls unless you are on VPN. Please contact the Network Team if you continue to experience the problem after connecting to a VPN!
      </q>
    </div>
  );
};

export default VpnRequired;